export default "__VITE_ASSET__cKXhg56V__"